import React from 'react'
import classNames from 'classnames'

import './MessageStatus.css'

export default function MessageStatus({ conversation }) {
  const styleClasses = classNames('far fa-lg', {
    'msg-unread': !conversation.read,
    'fa-envelope text-danger': conversation.status !== 'open',
    'fa-envelope-open text-success': conversation.status === 'open',
  });

  return <i className={styleClasses} aria-hidden="true"></i>
}
